module.exports = __webpack_public_path__ + "static/Portrait-of-Zach-min-63c0cd946151c354cae2f931c930551a.webp";